export function dotFormat(timestamp) {
  const time = new Date(timestamp);

  const year = time.getFullYear();
  const month = time.getMonth() < 9 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1);
  const date = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
  return `${year}.${month}.${date}`;
}

export function wordFormat(timestamp) {
  const year = timestamp.getFullYear();
  const month = timestamp.getMonth() + 1;
  const date = timestamp.getDate();

  return `${year}년 ${month}월 ${date}일`;
}



// WEBPACK FOOTER //
// ./src/utils/dateFormat.js